export { default as Img200 } from './processed/200/Syriana.jpg';
export { default as Img400 } from './processed/400/Syriana.jpg';
export { default as Imgthumb } from './processed/thumb/Syriana.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Syriana.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Syriana.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      188,
      140,
      84
    ],
    "_population": 1,
    "_hsl": [
      0.08974358974358976,
      0.43697478991596644,
      0.5333333333333333
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      196,
      132
    ],
    "_population": 1,
    "_hsl": [
      0.10256410256410257,
      0.7323943661971832,
      0.7215686274509805
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      71,
      37,
      19
    ],
    "_population": 45,
    "_hsl": [
      0.0576923076923077,
      0.5777777777777777,
      0.17647058823529413
    ]
  },
  "Muted": {
    "_rgb": [
      165,
      121,
      95
    ],
    "_population": 99,
    "_hsl": [
      0.06190476190476188,
      0.28,
      0.5098039215686274
    ]
  },
  "LightMuted": {
    "_rgb": [
      196,
      184,
      170
    ],
    "_population": 126,
    "_hsl": [
      0.08974358974358972,
      0.18055555555555566,
      0.7176470588235294
    ]
  },
  "DarkMuted": {
    "_rgb": [
      82,
      52,
      41
    ],
    "_population": 967,
    "_hsl": [
      0.04471544715447153,
      0.3333333333333333,
      0.24117647058823533
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Syriana.js